import { Button } from "@upstageai/ui";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import { envVarStore } from "../../utils/mobx/EnvVarStore";
import { staticLabelStore } from "../../utils/mobx/StaticLabelStore";
import Avatar from "../Avatar/Avatar";
import { Icon } from "../Icon";
import { Icons } from "../Icon/generated";

const GNBHeader = observer(() => {
  const { auth } = useAuth();
  const { staticLabels } = staticLabelStore;
  const { loginRequired } = envVarStore;

  return (
    <header className="z-30 flex w-full items-center justify-between bg-subtle">
      <div className="flex h-[56px] items-center gap-3 px-2.5 pl-5">
        <Icon source={Icons.UpstageBlack} />
        {staticLabels?.Common?.Message?.AppName?.[1] ? (
          <div className="text-xl">
            {staticLabels.Common.Message.AppName[0]}
          </div>
        ) : (
          <></>
        )}
      </div>

      <div
        data-gtm-position="nav-top"
        className="flex h-full items-center gap-3 pl-5 pr-3"
      >
        <>
          <div className="flex items-center justify-center">
            {loginRequired === "true" &&
              (auth.user ? (
                <Link to="/account">
                  <Avatar />
                </Link>
              ) : (
                <Link to="/login">
                  <Button>Login</Button>
                </Link>
              ))}
          </div>
        </>
      </div>
    </header>
  );
});

export default GNBHeader;
